import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PromiseStatuses } from "../../lib/types";
import { OTPRequest } from "../otp/dto";
import { LoginRequestDTO } from "./dto";
import { NewLoginService } from "./service";

interface LoginState {
    loginStatus: PromiseStatuses
    loginRequest: LoginRequestDTO
    loginResponse?: string
    OTPStatus: PromiseStatuses
    OTPRequest: OTPRequest
    verifyTokenStatus: PromiseStatuses
}

const initialState: LoginState = {
    loginStatus: "idle",
    loginRequest: {
        email: "",
        password: ""
    },
    OTPStatus: "idle",
    OTPRequest: {
        phoneNumber: ""
    },
    verifyTokenStatus: "idle",
}

export const login = createAsyncThunk(
    'cataniacruise/login',
    async (request: LoginRequestDTO): Promise<string> => {
        const loginService = NewLoginService()

        return loginService.login(request)
    }
)

export const OTP = createAsyncThunk(
    'cataniacruise/OTP',
    async (params: { request: OTPRequest; token: string }): Promise<void> => {
        const loginService = NewLoginService()

        return loginService.OTP(params.request, params.token)
    }
)

export const verifyToken = createAsyncThunk(
    'cataniacruise/verifyToken',
    async (token: string): Promise<void> => {
        const loginService = NewLoginService()

        return loginService.verifyToken(token)
    }
)

const loginSlice = createSlice({
    name: "login/slice",
    initialState,
    extraReducers(builder) {
        builder
            .addCase(login.pending, (state) => {
                state.loginStatus = 'loading'
            })
            .addCase(login.fulfilled, (state, action) => {
                state.loginStatus = 'successfully'
                state.loginResponse = action.payload
            })
            .addCase(login.rejected, (state) => {
                state.loginStatus = 'failed'
            })
            .addCase(OTP.pending, (state) => {
                state.OTPStatus = 'loading'
            })
            .addCase(OTP.fulfilled, (state, action) => {
                state.OTPStatus = 'successfully'
            })
            .addCase(OTP.rejected, (state) => {
                state.OTPStatus = 'failed'
            })
            .addCase(verifyToken.pending, (state) => {
                state.verifyTokenStatus = 'loading'
            })
            .addCase(verifyToken.fulfilled, (state, action) => {
                state.verifyTokenStatus = 'successfully'
            })
            .addCase(verifyToken.rejected, (state) => {
                state.verifyTokenStatus = 'failed'
            })
    },
    reducers: {
        setEmail: (state, action) => {
            state.loginRequest.email = action.payload
        },
        setPassword: (state, action) => {
            state.loginRequest.password = action.payload
        },
        setOTPPhoneNumber: (state, action) => {
            state.OTPRequest.phoneNumber = action.payload
        },
        setOTPStatus: (state, action) => {
            state.OTPStatus = action.payload
        },
        setVerifyTokenStatus: (state, action) => {
            state.verifyTokenStatus = action.payload
        }
    }
})

export const {
    setEmail,
    setPassword,
    setOTPPhoneNumber,
    setOTPStatus,
    setVerifyTokenStatus
} = loginSlice.actions

export default loginSlice.reducer